// @ts-nocheck
import { combineReducers } from "redux";
import backOrdersReducer, { BackOrdersActions } from "@store/Framework/Store/Pages/BackOrders/BackOrdersReducer";

const pagesReducers = {
    backOrders: backOrdersReducer,
};

export type StorePagesActions = BackOrdersActions;
export default combineReducers(pagesReducers);
